import { render, staticRenderFns } from "./DashboardLogViewer.vue?vue&type=template&id=5b415c96"
import script from "./DashboardLogViewer.vue?vue&type=script&lang=js"
export * from "./DashboardLogViewer.vue?vue&type=script&lang=js"
import style0 from "./DashboardLogViewer.vue?vue&type=style&index=0&id=5b415c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports